import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import Button from '../../../atoms/buttons/Button';
import { SvgIcon } from '@material-ui/core';
import { CancelRounded } from '@material-ui/icons';
import typography from '../../../theme/typography';
import borders from '../../../theme/borders';
import { IConfirmActionProps } from './types/ConfirmAction';
import { isDarkMode } from '../../../utils/helpers';
import breakpoints from 'theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ContainerDiv = styled('div')<{ centerAlign: boolean }>(
  {
    paddingTop: 0,
  },
  ({ centerAlign }) =>
    !centerAlign && {
      padding: '20px 0',
    },
  ({ customContainerDiv }: { customContainerDiv: React.CSSProperties }) =>
    customContainerDiv && { ...customContainerDiv }
);

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const HeaderDiv = styled('div')<{ centerAlign: boolean }>(
  {
    textAlign: 'center',
    marginTop: 26,

    [breakpoints.down(639.05)]: {
      marginTop: 12,
    },
  },
  ({ centerAlign }: { centerAlign: string }) =>
    !centerAlign && {
      textAlign: 'left',
      padding: '0 20px',
    },
  ({ customHeaderDiv }: { customHeaderDiv: React.CSSProperties }) => customHeaderDiv && { ...customHeaderDiv }
);

const ModalTitle = styled('span')(
  () => {
    const theme = isDarkMode() ? 'dark' : 'light';

    return {
      color: typography[theme].heading,
      fontSize: 24,
      lineHeight: '29px',
      fontStyle: 'normal',
      fontWeight: 600,
      display: 'block',
      marginBottom: 15,

      [breakpoints.down(639.05)]: {
        fontSize: 22,
        lineHeight: '27px',
      },
    };
  },
  ({ customLabel }: { customLabel: React.CSSProperties }) => customLabel && { ...customLabel }
);

const ButtonDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  marginTop: 18,
});

const IconDiv = styled('div')<{ centerAlign: boolean }>(
  {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
    marginBottom: 10,
  },
  ({ centerAlign }) =>
    !centerAlign && {
      justifyContent: 'start',
    }
);

const ModalContent = styled('div')<{ centerAlign: boolean }>(
  () => {
    const theme = isDarkMode() ? 'dark' : 'light';

    return {
      display: 'flex',
      justifyContent: 'center',
      flexFlow: 'column',
      fontSize: 16,
      color: typography[theme].primaryText,
      fontWeight: 400,
      lineHeight: '21px',

      [breakpoints.down(639.05)]: {
        fontSize: 15,
        lineHeight: '20px',
      },
    };
  },
  ({ centerAlign }) =>
    !centerAlign && {
      textAlign: 'left',
    }
);

const CloseBtn = styled('button')({
  appearance: 'none',
  border: 'none',
  background: 'none',
  width: '48px',
  height: '48px',
  position: 'absolute',
  top: 15,
  right: 15,
});

const closeButton = {
  fontSize: 24,
  color: !isDarkMode() ? typography.light.secondaryText : borders.dark.primary,
};

const customButtonstyle = {
  fontSize: 14,
  padding: '12px 22px',
};

const ConfirmAction = ({
  title = '',
  message = '',
  buttonID = '',
  cancelText = 'No',
  confirmText = 'Yes',
  cancelAction,
  confirmAction,
  modalIcon,
  centerAlign = true,
  withCancel = true,
  hideCloseBtn = false,
  closeBtnClassName,
  closeBtnDataTestId,
  customHeaderDiv,
  customContainerDiv,
  customLabel,
  customCloseBtnStyle,
  confirmBtnType,
}: IConfirmActionProps): ReactElement => {
  return (
    <ContainerDiv
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      centerAlign={centerAlign}
      customContainerDiv={customContainerDiv}
    >
      <HeaderDiv
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        centerAlign={centerAlign}
        customHeaderDiv={customHeaderDiv}
      >
        <IconDiv centerAlign={centerAlign}>{modalIcon}</IconDiv>
        {hideCloseBtn && (
          <CloseBtn
            className={closeBtnClassName}
            data-test-id={closeBtnDataTestId}
            // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
            onClick={cancelAction}
            style={customCloseBtnStyle}
          >
            <SvgIcon component={CancelRounded} style={closeButton} />
          </CloseBtn>
        )}
        <ModalTitle
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          centerAlign={centerAlign}
          customLabel={customLabel}
        >
          {title}
        </ModalTitle>
        <ModalContent centerAlign={centerAlign}>{message}</ModalContent>
      </HeaderDiv>
      <ButtonDiv>
        {withCancel && (
          <Button
            buttonType="secondaryRed"
            onClick={cancelAction}
            data-test-id={`${buttonID}-cancel`}
            type="submit"
            customStyle={{
              ...customButtonstyle,
              borderRadius: '4px !important',
              marginRight: 20,
            }}
          >
            {cancelText}
          </Button>
        )}
        <Button
          buttonType={confirmBtnType}
          data-test-id={`${buttonID}-confirm`}
          customStyle={{
            borderRadius: '4px !important',
            ...customButtonstyle,
          }}
          onClick={e => {
            // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
            confirmAction(e);
            e.preventDefault();
          }}
        >
          {confirmText}
        </Button>
      </ButtonDiv>
    </ContainerDiv>
  );
};

export default ConfirmAction;
